/**
 * Component displays the button with predefined (onstants) values
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual } from 'react-redux';
import { Stack, Text, Image, IImageProps } from '@fluentui/react';
import {
    appStyles,
    getImageByContetntType,
    resolveThemeColors,
    Utilities,
} from '../../helpers';
import { useAppSelector } from '../../store';
import { FolderIcon } from './folderIcon';
import { FileType } from '../../model';

/** Loose view of FileItem / ServerFile — this component renders both */
type FileItemView = {
    name: string;
    contenttype?: string;
    type?: FileType;
    shared?: boolean;
    parentPath?: string;
    lastmod?: string | Date;
    content?: ArrayBuffer;
    readableContent?: File | Blob;
};

type Props = {
    item: FileItemView;
    displayPath?: boolean;
    destinationFolder?: unknown;
    destinationFolderPath?: string;
};

// Server files carry neither buffered nor streamed content
const hasLocalContent = (item: FileItemView): boolean =>
    item.content !== undefined || item.readableContent !== undefined;

const File = (props: Props) => {
    const colors = useAppSelector(resolveThemeColors, shallowEqual);

    const getImageByType = (
        contenttype: string,
        type: FileType | undefined,
        name: string,
    ) => {
        const img = getImageByContetntType(contenttype, type, name);
        const ControlImage: IImageProps = {
            src: img,
            height: '22px',
        };
        return ControlImage;
    };

    return (
        <Stack horizontal key={props.item.name} tokens={{ childrenGap: 5 }}>
            <Stack style={{ width: '25px' }} verticalAlign="center">
                {props.item.type === 'directory' ? (
                    <FolderIcon
                        shared={props.item.shared}
                        size={22}
                        color={colors.icon}
                    />
                ) : (
                    <Image
                        {...getImageByType(
                            props.item.contenttype ?? '',
                            props.item.type,
                            props.item.name,
                        )}
                    />
                )}
            </Stack>
            <Stack verticalAlign="center">
                <Text className={appStyles.globalStyles.file}>
                    {' '}
                    {props.displayPath === true
                        ? `${props.item.parentPath}/${props.item.name}`
                        : props.item.name}
                </Text>
                <Text className={appStyles.globalStyles.date}>
                    {' '}
                    {Utilities.parseDatetime(props.item.lastmod)}
                </Text>
                {hasLocalContent(props.item) &&
                !Utilities.isNANObject(props.destinationFolder) ? (
                    <Text
                        className={appStyles.globalStyles.date}
                        // eslint-disable-next-line max-len
                    >{`${props.destinationFolderPath}`}</Text>
                ) : (
                    <></>
                )}
            </Stack>
        </Stack>
    );
};

export default File;

File.propTypes = {
    item: PropTypes.any,
    displayPath: PropTypes.bool,
    destinationFolder: PropTypes.any,
};
